import {SmContainerContextMenuComponent} from '../sm-inventory-context-menu/sm-inventory-context-menu.component';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {SmSearchHighlightComponent} from '../sm-search-highlight/sm-search-highlight.component';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SmContextMenuModule} from '../sm-context-menu/sm-context-menu.module';
import {SmImagePreviewModule} from '../sm-image-preview/sm-image-preview.module';
import {SmRichTooltipModule} from '../sm-rich-tooltip/sm-rich-tooltip.module';
import {SmContainerListItemComponent} from './sm-container-list-item.component';

@NgModule({
  imports: [SmContainerContextMenuComponent,
    CommonModule,
    SmSearchHighlightComponent,
    TranslateModule,
    IonicModule,
    SmContextMenuModule,
    SmImagePreviewModule,
    SmRichTooltipModule,
  ],
  declarations: [SmContainerListItemComponent],
  exports: [SmContainerListItemComponent],
})
export class SmContainerListItemModule {}
